var _react_refresh_temp_1;
_react_refresh_temp_1 = $RefreshSig$();
import { useState } from 'react';
export const useDiagnosticReportFlow = () => {
    _react_refresh_temp_1();
    const [isDiagnosticReportFlowInProgress, setIsDiagnosticReportFlowInProgress,] = useState(false);
    return {
        setIsDiagnosticReportFlowInProgress,
        isDiagnosticReportFlowInProgress,
    };
};
_react_refresh_temp_1(useDiagnosticReportFlow, "0xqSwHoHQ9HjJsnNNH5FE2hKV+M=");
